import axios from '../axiosv2';
const presignedUrl = (method, bucketName, keyName) => {
    return axios
        .get('/v2/presignUrlaudioS3', {
        // cancelToken: source.token,
        params: {
            method,
            bucketName,
            keyName
        }
    })
        .then(({ data }) => Promise.resolve(data))
        .catch(error => {
        return Promise.reject(error.response.data);
    });
};
export default presignedUrl;
